package ovh.plrapps.mapcompose.utils

data class Point(val x: Double, val y: Double)
